<template>
  <div id="promo_page">

    <div style="width:80%; margin:0 auto; direction:ltr" dir="ltr">
    <carousel items="1" :nav="false">

        <div v-for="pic in item.promo_gallery" :key="pic.id"><img  :src="pic.url_download" alt="" /></div>

          <template slot="next" v-if="item.promo_gallery.length > 1"><span class="prev material-icons">chevron_left</span></template>
          <template slot="prev" v-if="item.promo_gallery.length > 1"><span class="next material-icons">chevron_right</span></template>
    </carousel> 
    
    </div>
    

  </div>
</template>

<script>

import carousel from 'vue-owl-carousel'

export default {
  props: ["widgets", "item"],
  components: { carousel },
  created(){
    
    
  }
}
</script>

<style scoped>
#promo_page { overflow: hidden;}
@media only screen and (min-width: 700px) {
  #promo_page img { max-height: 70vh; width:auto; margin: 0 auto; }
}
</style>